import { IConfirmableInjectedAction } from '../../../../interfaces';

export class InjectedFailedCasesMigration implements IConfirmableInjectedAction {
  performActionAfterConfirm = () => {

  }
}
